/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./error.vue.js?vue&type=template&id=01cdec20!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./error.vue?vue&type=template&id=01cdec20"
import script from "./error.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./error.vue?vue&type=script&lang=ts&setup=true"
export * from "./error.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./error.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./error.vue.postcss?vue&type=style&index=0&id=01cdec20&prod&lang=postcss&module=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./error.vue?vue&type=style&index=0&id=01cdec20&prod&lang=postcss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports